import { render, staticRenderFns } from "./Avicola.vue?vue&type=template&id=4dbad850&scoped=true"
import script from "./Avicola.vue?vue&type=script&lang=js"
export * from "./Avicola.vue?vue&type=script&lang=js"
import style0 from "./Avicola.vue?vue&type=style&index=0&id=4dbad850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbad850",
  null
  
)

export default component.exports